import { createFileRoute } from '@tanstack/react-router';
import { UserTable } from '@/components/Pages/Users/UserTable';
import { CreateEditUserModal } from '@/components/Pages/Users/CreateEditUserModal';
import { UserCommissionReport } from '@/components/Pages/Users/UserCommissionReport';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/users/')({
  component: UsersPage,
});

function UsersPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  return (
    <Box>
      {showActions && (
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3, gap: 2 }}
        >
          <CreateEditUserModal />
          <UserCommissionReport />
        </Box>
      )}
      <UserTable />
    </Box>
  );
}
